import * as React from 'react';
import PropTypes from 'prop-types';

import s from './Loader.pcss';


export default class Loader extends React.Component {
  static propTypes = {
    fullScreen: PropTypes.bool,
    size: PropTypes.number,
  };

  static defaultProps = {
    fullScreen: true,
    size: 96,
  };

  render() {
    const { fullScreen, size } = this.props;
    const className = fullScreen ? s.loader : s.innerLoader;
    return (
      <div className={className}>
        <div className={s.spinner} style={{ height: size, width: size, borderWidth: size / 16 }} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/Loader/Loader.js